<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Operators'"
        :buttons="[
          {
            title: 'Add Operator',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Operators'"
        ref="agGrid"
        :data="data"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        :operators="data"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "scanErrors",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`operators`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the operator named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Operators/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The operator was successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
